<template>
    <div>
        <div v-if="loading" class="text-center py-3">
            <i class="fas fa-spinner fa-2x fa-pulse text-primary"></i>
        </div>
        <div v-else>
            <!-- Error Display -->
            <div v-if="result.errors && Object.keys(result.errors).length > 0" class="alert alert-danger">
                <h6>Errors Detected:</h6>
                <ol>
                    <li v-for="(message, key) in result.errors" :key="key">
                        <strong>{{ key }}:</strong>
                        <ol>
                            <li v-for="(error, index) in message" :key="index">{{ error }}</li>
                        </ol>
                    </li>
                </ol>
            </div>

            <!-- Account Found with Empty Data (Show Unexpected Error) -->
            <div v-else-if="result.message === 'Account found' && (!result.data || Object.keys(result.data).length === 0)" class="alert alert-danger">
                Sorry, {{ name }} failed with error: failed to process your request.
            </div>

            <!-- Successful Data Display -->
            <div v-else-if="result.success && result.data && Object.keys(result.data).length > 0" class="alert alert-primary">
                <div v-for="(value, key) in result.data" :key="key" class="mb-0">
                    <span class="text-capitalize">{{ key.replace(/_/g, ' ') }}:</span>
                    <strong>{{ value }}</strong>
                </div>
            </div>

            <!-- Default Message for Success Without Data -->
            <div v-else-if="result.success" class="alert alert-primary">
                {{ result.message }}
            </div>

            <!-- Fallback for unexpected errors -->
            <div v-else class="alert alert-danger">
               Sorry, {{ name }} failed with error: failed to process your request.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LookupResult',
    props: {
        result: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: false,
            default: 'Service'
        },
    }
}
</script>
